<script setup lang="ts">
import { useSelectAlertType } from '../../../model/additional-info/success/info-health-check/select-alert-type.hook'
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'
import RowTaskInfo from '../../task-info/RowTaskInfo.vue'
import SelectCustomerType from './info-customer-type/SelectCustomerType.vue'

defineOptions({
  name: 'InfoCustomerType',
})

const { isRequired } = useSelectAlertType()

</script>

<template>
  <ListTaskInfo>
    <RowTaskInfo
      title="Customer type"
      :required="isRequired"
    >
      <SelectCustomerType />
    </RowTaskInfo>
  </ListTaskInfo>
</template>
